module.exports = __webpack_public_path__ + "media/images/icons/instagram_white-5a4ee117a3e98fd863a6adaf156839bd.svg";